import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

const FAQ = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#0B0B0B] mb-4 font-playfair">Frequently Asked Questions</h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">Everything you need to know about our services</p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="border border-gray-200 rounded-lg px-6 hover:border-[#C9A227] transition-colors duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-[#0B0B0B] hover:text-[#C9A227] transition-colors py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div className="mt-12 text-center p-8 bg-gray-50 rounded-2xl">
          <p className="text-lg text-gray-600 mb-2">Still have questions?</p>
          <p className="text-gray-500">Contact us via WhatsApp or visit any of our branches</p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;